import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/gravitational-force-calculator',
  component: () => import('../../routes/GravitationalForceCalculator.svelte'),
  card: {
    id: 'gravitational-force-calculator',
    title: 'Gravitational Force Calculator',
    description: 'Calculate gravitational attraction between two masses using Newton\'s Law of Universal Gravitation. Also computes orbital velocity, escape velocity, and surface gravity on planets.',
    icon: 'public',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/gravitational-force-calculator',
    category: 'Physics & Science',
  },
  seo: {
    title: 'Gravitational Force Calculator – F = Gm₁m₂/r² (Newton\'s Law of Universal Gravitation)',
    description: 'Free gravitational force calculator using Newton\'s Law of Universal Gravitation. Calculate force between two masses, orbital velocity, escape velocity, and surface gravity on planets. Instant, accurate results.',
  },
};

export default meta;